import { AuthLayout } from '../components/AuthLayout';
import { AuthHeroPanel } from '../components/AuthHeroPanel';
import { RegisterForm } from '../components/RegisterForm';

/**
 * Register Page
 * Two-panel layout with hero image and registration form
 * Auth redirect logic is now handled by AppRouter route guards
 */
export function RegisterPage() {
  return (
    <AuthLayout showSignUpLink={false}>
      <div className="w-full max-w-[90vw] sm:max-w-[95vw] md:max-w-[600px] lg:max-w-[1000px] xl:max-w-[1100px] grid grid-cols-1 lg:grid-cols-2 bg-surface rounded-lg sm:rounded-xl shadow-auth-card overflow-hidden border border-primary/5">
        {/* Left Panel - Hero */}
        <AuthHeroPanel />

        {/* Right Panel - Form */}
        <RegisterForm />
      </div>
    </AuthLayout>
  );
}
